import TournamentSplashHeroListItem from './TournamentSplashHeroListItem';

export default TournamentSplashHeroListItem;
